import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import AppProviders from './utils/contexts';
import checkoutClient from './logic/checkout';

// Deliver any order still queued from a previous session, then retry
// whenever connectivity comes back.
checkoutClient.flushOutbox();
window.addEventListener("online", checkoutClient.flushOutbox);

ReactDOM.render(
    <AppProviders>
        <App />
    </AppProviders>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
